import React from 'react';
import { Tooltip as AntTooltip } from 'antd';
import { toSafeHtml } from '@/utils/sanitizeHtml'
interface CustomTooltipProps {
    value?: string | null;
    title?: string | null;
    children: React.ReactNode;
    placement?:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom';
    /** Điều khiển mở/đóng (tuỳ chọn) — vd. tooltip chỉ mount khi hover lần đầu. */
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
    title = null,
    value = null,
    children,
    placement = 'top',
    open,
    onOpenChange,
}) => {
    if (!value || !value.trim()) {
        return <>{children}</>;
    }

    return (
        <AntTooltip
            placement={placement}
            {...(open !== undefined ? { open } : {})}
            onOpenChange={onOpenChange}
            color="white"
            classNames={{
                root: 'custom-tooltip-border',
            }}
            styles={{
                root: {
                    border: '1px solid #1890ff',
                    borderRadius: '4px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    width: 'max-content',
                    maxWidth: '100%',
                },
                body: {
                    color: 'black',
                    textAlign: 'left',
                    padding: '10px',
                    width: 'max-content',
                    maxWidth: '100%',
                },
            }}
            title={
                <div
                    onPointerDown={(e) => e.stopPropagation()}
                >
                    {title && <div style={{ fontWeight: 600, marginBottom: 6 }}>{title}</div>}
                    <div
                        className="tooltip-custom"
                        dangerouslySetInnerHTML={toSafeHtml(value)}
                        style={{ lineHeight: '1.3' }}
                    />
                </div>
            }
      
        >
            {children}
        </AntTooltip>
    );
};

export default CustomTooltip;
